import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=0e74259d&"
import script from "./Feedbacks.vue?vue&type=script&lang=ts&"
export * from "./Feedbacks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports